exports = module.exports = require("./../../node_modules/.0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".panel-view{padding:0 10px}", "", {"version":3,"sources":["/./src/views/panelView.vue"],"names":[],"mappings":"AACA,YACE,cAAgB,CACjB","file":"panelView.vue","sourcesContent":["\n.panel-view {\n  padding: 0 10px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.25.0@css-loader?sourceMap!./~/.10.0.2@vue-loader/lib/style-rewriter.js?id=data-v-3cadbc1d!./~/.10.0.2@vue-loader/lib/selector.js?type=styles&index=0!./src/views/panelView.vue
// module id = 74
// module chunks = 0